import { message } from 'antd';
import { put, takeLatest } from 'redux-saga/effects';
import { TemplateDraft } from 'api/models';
import { StoreActionProps } from 'data/core';
import { TemplateObjectType, TemplatesAPI } from 'data/templates/api';
import {
  deleteTemplateFromIndexedDb,
  getTemplateDraftFromIndexedDb,
} from 'hooks/use-idb';
import { logger } from 'services';
import {
  FetchDocumentTemplateAction,
  fetchDocumentTemplateAction,
} from '../actions';
import {
  fetchDocumentTemplateStart,
  fetchDocumentTemplateStartSuccess,
} from '../slices';
import { DocumentTemplate } from '../types';

function* fetchdocumentTemplateSaga(
  action: StoreActionProps<FetchDocumentTemplateAction>,
) {
  try {
    const {
      payload: { templateId },
    } = action;

    yield put(fetchDocumentTemplateStart({ templateId }));

    let template: DocumentTemplate =
      yield TemplatesAPI.getById<DocumentTemplate>(templateId);

    const dataFromIdb: TemplateDraft = yield getTemplateDraftFromIndexedDb(
      parseInt(String(templateId), 10),
    );

    if (
      dataFromIdb != null &&
      dataFromIdb.content != null &&
      dataFromIdb.content.objectType === TemplateObjectType.Document
    ) {
      if (
        dataFromIdb.timestamp >
          (template.publishedAt ?? template.createdAt ?? 0) &&
        dataFromIdb.content != null
      ) {
        template = dataFromIdb.content;
      } else {
        yield deleteTemplateFromIndexedDb([templateId]);
      }
    }

    yield put(fetchDocumentTemplateStartSuccess(template));
  } catch (error) {
    logger.error('an error fetching the document', { error });

    message.error('There was an error fetching the document');
  }
}

export function* watchFetchDocumentTemplateSaga(): Generator {
  yield takeLatest(fetchDocumentTemplateAction.type, fetchdocumentTemplateSaga);
}
